import { useState } from 'react';
import { Grid, Button, Divider } from '@mui/material';
import LogKiln from './LogKiln';
import Buckets from './Buckets';
import Equipment from './Equipment';

/**
 * Shared component between Flame Cap Kilns and Conservation Burns
 * @param {Object} props 
 * @param {'Flame Cap Kiln' | 'Conservation Burns'} props.burnType Prop drilled down from Programs.js
 * @returns {JSX.Element}
 */

export default function Assets({ burnType }) {
    const [selectedCategory, setSelectedCategory] = useState('Log Kiln');

    const categories = [
        'Log Kiln',
        'Buckets',
        'Equipment'
    ];

    // Tentative feature, not yet shown to clients. Remove from this list to show it.
    const hiddenCategories = ['Equipment'];

    return (
        <>
            <Grid item xs={12} sx={{ display: 'flex', gap: 2 }}>
                {categories.map(category => (
                    <Button
                        key={category}
                        onClick={() => setSelectedCategory(category)}
                        variant={selectedCategory === category ? 'contained' : 'outlined'}
                        sx={hiddenCategories.includes(category) ? { display: 'none' } : undefined}
                    >
                        {category}
                    </Button>
                ))}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                {
                    selectedCategory === 'Log Kiln' &&
                    <LogKiln burnType={burnType} />
                }
                {
                    selectedCategory === 'Buckets' &&
                    <Buckets />
                }
                {
                    selectedCategory === 'Equipment' &&
                    <Equipment />
                }
            </Grid>
        </>
    );
}
